import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE } = BASE_WIDTH_COLUMNS;

const accountingReplenishPerformersBalance = makeTable({
	allIds: [
		"executorCallSign",
		"paymentDate",
		"type",
		"paymentSystem",
		"serviceId",
		"paymentSum",
		"notes",
		"dispatcherFullName",
	],
	i18tPath: (id) =>
		`mainPage.accounting.replenishPerformersBalance.columns.${id}`,
	defaultIds: [
		"executorCallSign",
		"paymentDate",
		"type",
		"paymentSystem",
		"serviceId",
		"paymentSum",
		"notes",
		"dispatcherFullName",
	],
	initialSortMethod: {
		column: "paymentDate",
		type: "desc",
	},
	initialWidths: {
		executorCallSign: 150,
		paymentDate: DATE,
		type: 120,
		paymentSystem: 180,
		serviceId: 180,
		paymentSum: 140,
		notes: 250,
		dispatcherFullName: 250,
	},
	initialResizable: {
		executorCallSign: true,
		paymentDate: true,
		type: true,
		paymentSystem: true,
		serviceId: true,
		paymentSum: true,
		notes: true,
		dispatcherFullName: true,
	},
	initialSortable: {
		executorCallSign: true,
		paymentDate: true,
		type: true,
		paymentSystem: true,
		serviceId: true,
		paymentSum: true,
		notes: true,
		dispatcherFullName: true,
	},
});

export default accountingReplenishPerformersBalance;
